import React, { memo, ReactNode } from 'react'
import { Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IMenuHeaderProps {
  children: ReactNode
}

const useMenuHeaderStyles = makeStyles(theme => ({
  root: {
    color: brandColors.coolGray8,
    marginBottom: theme.spacing(1),
  },
}))

const MenuHeader = memo<IMenuHeaderProps>(({ children }) => {
  const classes = useMenuHeaderStyles()
  return (
    <Typography variant='subtitle2' component='div' className={classes.root}>
      {children}
    </Typography>
  )
})

export default MenuHeader
